import { createContext } from "react";

export const ModelosContext = createContext()
export const ModelosFormContext = createContext()
export const ModelosReportContext = createContext()